import React from 'react';
import {
  ItemContainer,
  ItemContainerText,
  ItemContainerHeader,
  ItemContainerFooter,
} from '../../Item';
import { Row, Col, InputGroup, Input } from 'reactstrap';
import Indicator, { IndicatorStateOptions } from '../../Indicator';
import InformationButton from '../../Item/InformationButton';
import ErrorField from '../../../containers/Fields/ErrorField';

export type NumberInputRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: any;
};

const NumberInput = (props: NumberInputRenderProps) => {
  const {
    text,
    enabled,
    supportingLink,
    informationText,
    indicatorState: state,
  } = props;
  return enabled === undefined || enabled ? (
    <ItemContainer pulsing={enabled !== undefined}>
      <ItemContainerText text={text}>
        {supportingLink ? <InformationButton onClick={supportingLink} /> : null}
      </ItemContainerText>
      <ItemContainerHeader>
        <div className="d-flex flex-row-reverse justify-content-between">
          {informationText
            ? informationText.map((info, index) => (
                <div key={index} className={'d-inline-flex'}>
                  <em className={'i-information-text'}>{info}</em>
                </div>
              ))
            : null}
        </div>
      </ItemContainerHeader>
      <Row noGutters={true} className="ic-item m-2">
        <Col>
          <InputGroup>
            <Input
              placeholder="Insert a number"
              type="number"
              name={props.name}
              checked={props.check}
              onBlur={props.onBlur}
              onFocus={props.onFocus}
              onChange={props.onChange}
              value={props.value}
              disabled={props.disabled}
            />
          </InputGroup>
        </Col>
      </Row>
      <ItemContainerFooter>
        <div className="d-flex flex-row-reverse align-items-center ">
          <Indicator state={state} />
          <ErrorField name={props.name} />
        </div>
      </ItemContainerFooter>
    </ItemContainer>
  ) : null;
};
export default NumberInput;
